<template>
	<div class="basic_wrap background">
		<!-- 返回按钮 -->
		<div class="back-btn" @click="$router.go(-1)">
			<img src="../images/draw/back.png" />
		</div>

		<div class="content">
		      <h2>Referral Rewards Chest</h2>
		      <p>Unlock a Referral Chest for every direct user who completes a top-up through your invitation!</p>
		      <p>Boxes:<strong>{{ boxes.boxes }}</strong></p>
			  <p>Opened：<strong>{{ boxes.openedBoxes.length }}</strong></p>
			  <p>Unopened：<strong>{{ boxes.boxes-boxes.openedBoxes.length }}</strong></p>
		
		      <!-- 宝箱网格 -->
		      <div class="reward-grid">
		        <div
		          v-for="box in rewardBoxes"
		          :key="box.id"
		          class="reward-box"
		          @click="tryOpenRewardBox(box)"
		          :class="{ clickable: box.unlocked }"
		        >
		          <!-- 宝箱图片 -->
				  <div class="img-container">
					<img :src="getBoxImage(box)" alt="box image" />
				  </div>
		          <!-- 宝箱说明 -->
		          <p>{{ box.id }} -Ref Chest</p>
		        </div>
		      </div>
		
		    
		    </div>
	</div>
</template>

<script>
import Fetch from "../../utils/fetch";
import Vue from "vue";
import { Empty, Toast,Dialog } from "vant";

Vue.use(Empty);
// Vue.use(Toast);
export default {
  data() {
    return {
		boxes:{
			boxes:0,
			openedBoxes:[],
			maxBoxes:30
		},
		rewardBoxes: [], // 宝箱的列表数据
    };
  },
  created() {
	this.$parent.footer('user', false);
	this.fetchData()
  },
  methods: {
	async fetchData(){
		try{
			const response = await Fetch("/user/box");
			this.boxes = {
				...response.data,
				openedBoxes:response.data.openedBoxes?.map(opened=>opened.box_index), //扁平下数组
			};
			console.log("boxes data",this.boxes)
			this.generateRewardBoxes(this.boxes); // 初始化宝箱数据
		}catch(e){
			// 捕获接口调用异常
			console.error("box fetch error：", error);
			Toast.fail("Net Error");
		}
	},
    // 初始化宝箱的数据
    generateRewardBoxes(boxesData) {
		
      for (let i = 1; i <= boxesData.maxBoxes; i += 1) {
        this.rewardBoxes.push({
          id: i,
          unlocked: i<=boxesData.boxes, // 默认状态下是未解锁
          opened: boxesData.openedBoxes.includes(i), // 判断是否在已开启列表
        });
      }
    },
    // 根据宝箱状态获取宝箱图片
    getBoxImage(box) {
      if (box.opened) {
        return require('@/views/images/draw/box-opened.png'); // 宝箱已开启图片
      } else if (box.unlocked) {
        return require('@/views/images/draw/box-close.png'); // 宝箱已解锁但未打开
      } else {
        return require('@/views/images/draw/box-gray.png'); // 默认未解锁宝箱
      }
    },
	
    // 尝试打开宝箱
    tryOpenRewardBox(box) {
      if (box.opened) {
		  Dialog.alert({
		    message: 'This chest has already been opened!',
			confirmButtonText: window.vm.$i18n.t('utils.confirm')
		  }).then(() => {
			// on close
		  });
		  return;
      }
      if (!box.unlocked) {
		  Dialog.alert({
		    message: 'This chest hasn`t been unlocked yet, so please complete the quest and open it again!',
			confirmButtonText: window.vm.$i18n.t('utils.confirm')
		  }).then(() => {
		  			// on close
		  });
        return;
      }
	  // 触发宝箱开启逻辑
      this.openRewardBox(box).then(()=>{
		  
	  }); 
    },
    // 打开宝箱
    async openRewardBox(box) {
      box.opened = true; // 标记宝箱为已开启
	  try{
	  	const response = await Fetch("/user/boxReward",{box:box.id});
		console.log("response",response)
		const rewardMessage = `Successfully open the chest to obtain:${response.data.reward}！`;
		Dialog.alert({
		  message: rewardMessage,
		  confirmButtonText: window.vm.$i18n.t('utils.confirm')
		}).then(() => {
		  // on close
		});
		this.fetchData()
	  }catch(error){
	  	// 捕获接口调用异常
		box.opened = false
	  	console.error("boxReward fetch error：", error);
	  }
    }
  },
};
</script>
<style>
	
	#app{
		height: 100%;
		padding-bottom: 0 !important;
	}
</style>

<style scoped>
/* 整体容器样式 */
.invite-reward {
  text-align: center;
  padding: 20px;
  position: relative;
  overflow: hidden; /* 隐藏多余内容 */
}
.back-btn {
	position: fixed;
	top: 10px;
	left: 10px;
	img{
		width: 20px;
	}
}
h2{
	font-size: large;
	padding: 2px;
}
p{
	padding: 2px;
}
.background {
  /* 背景样式 */
  /* background: url(../images/draw/bg1.png) no-repeat center center; */
  background-color: #fd8d65;
  background-size: 100% 100%;
  height: 100%;
  color: white;
}
.content{
	margin-top: 58px;
	padding: 10px;
}
.reward-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr); /* 每行显示5列宝箱 */
  gap: 20px;
  margin-top: 20px;
  overflow: scroll;
}

.reward-box {
  text-align: center;
  transition: all 0.3s;
}

.reward-box .img-container{
	height: 13vw;
}
.img-container img {
  width: 12vw;
  height: auto;
  max-width: 100px;
  max-height: 100px;
}

.reward-box p {
  margin-top: 10px;
  font-size: 14px;
  color: white;
}

.reward-box.clickable:hover img {
  transform: scale(1.1); /* 鼠标悬浮效果 */
  cursor: pointer;
}

/* 模态框的外层遮罩 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7); /* 半透明的黑色背景 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* 模态框的内容 */
.modal-dialog {
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  text-align: center;
  width: 90%;
  max-width: 400px;
}

.modal-dialog p {
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: bold;
}

.modal-dialog button {
  padding: 10px 20px;
  background-color: #007bff; /* 按钮颜色 */
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.modal-dialog button:hover {
  background-color: #0056b3; /* 按钮悬浮颜色 */
}
</style>
